import { render, staticRenderFns } from "./DamagesList.vue?vue&type=template&id=c1360808&scoped=true"
import script from "./DamagesList.vue?vue&type=script&lang=js"
export * from "./DamagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1360808",
  null
  
)

export default component.exports